module.exports = __webpack_public_path__ + "media/images/icon_sidebar_price-58dc1017420043b6bf3de6bbec5b26ed.svg";